import React, { useState } from "react";
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import overlayFactory from 'react-bootstrap-table2-overlay';
import { listUserAction, approveUserAction, rejectUserAction, deleteUserAction } from '../../actions';
import moment from 'moment-timezone';
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import constants from "../../config/constants";


function AppUserList({ listUserAction, approveUserAction, rejectUserAction, deleteUserAction }) {
    const [loading, setLoading] = useState(true);
    const [properties, setProperties] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(20);
    const history = useHistory();
    const [tableState, setTableState] = useState(null);

    const confirmApprove = (id) => {
        confirmAlert({
            title: 'Are you sure?',
            message: 'Do you want approve this user?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        setLoading(true);
                        approveUserAction({ id: id }, (err, response) => {
                            if (!err) {
                                loadData(tableState);
                            }
                        });
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    };

    const confirmReject = (id) => {
        confirmAlert({
            title: 'Are you sure?',
            message: 'Do you want reject this user?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        setLoading(true);
                        rejectUserAction({ id: id }, (err, response) => {
                            if (!err) {
                                loadData(tableState);
                            }
                        });
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    };


    const confirmDelete = (ids) => {
        confirmAlert({
            title: 'Are you sure?',
            message: 'Do you want to delete this item?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        setLoading(true);
                        deleteUserAction({ ids: ids }, (err, response) => {
                            if (!err) {
                                loadData(tableState);
                            }
                        });
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    };

    const columns = [
        {
            dataField: 'firstName',
            text: 'First Name',
            filter: textFilter()
        },
        {
            dataField: 'lastName',
            text: 'Last Name',
            filter: textFilter()
        },
        {
            dataField: 'email',
            text: 'Email',
            filter: textFilter()
        },
        {
            dataField: 'role',
            text: 'Role',
            formatter: (cell, row) => {
                return <span className="badge badge-primary">{row.role}</span>
            },
            filter: selectFilter({
                options: {
                    'User': "User",
                    'WasteCollector': "Waste Collector",
                    "Introducer": "Introducer",
                    "Corporate": "Corporate",
                    "BusinessManager": "Business Manager"
                }
            })
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: (cell, row) => {
                if (row.status === 0) {
                    return <span className="badge badge-danger">Inactive</span>
                } else {
                    return <span className="badge badge-success">Active</span>
                }
            }
        },
        {
            dataField: 'createdAt',
            text: 'Created At',
            sort: true,
            formatter: (cell, row) => {
                return moment(row.createdAt).format('YYYY-MM-DD hh:mm a')
            }
        },
        {
            dataField: 'actions',
            text: 'Actions',
            isDummyField: true,
            csvExport: false,
            formatter: (cell, row) => {
                return <>
                    <button onClick={() => { history.push(`/app-users/view/${row._id}`) }} className="btn btn-outline-secondary mr-1"><i className="icon-eye"></i></button>
                    <button onClick={() => { history.push(`/app-users/update/${row._id}`) }} className="btn btn-outline-secondary mr-1"><i className="icon-pencil"></i></button>
                    {(((row.role === constants.ROLE.COLLECTOR) || (row.role === constants.ROLE.BUSINESS_MANAGER)) && (row.approvalStatus === 0)) && <button title="Approve" onClick={() => { confirmApprove(row.id); }} className="btn btn-outline-secondary mr-1"><i className="icon-check"></i></button>}
                    {(((row.role === constants.ROLE.COLLECTOR) || (row.role === constants.ROLE.BUSINESS_MANAGER)) && (row.approvalStatus === 0)) && <button title="Reject" onClick={() => { confirmReject(row.id) }} className="btn btn-outline-secondary mr-1"><i className="icon-close"></i></button>}
                    <button onClick={() => { confirmDelete([row._id]) }} className="btn btn-outline-secondary mr-1"><i className="icon-trash"></i></button>
                </>
            },
        },
    ];

    const loadData = (data) => {
        setLoading(true);
        listUserAction(data, (err, response) => {
            if (!err) {
                setProperties(response.data.data);
                setTotal(response.data.total);
            }
            setLoading(false);
        });
    }

    const onTableChange = (type, newState) => {
        setPage(newState.page);
        setSizePerPage(newState.sizePerPage);
        let data = { ...newState };
        data.perPage = newState.sizePerPage;
        delete data.data;
        setTableState(data);
        loadData(data);
    }

    return (
        <div className="col-lg-12">
            <div className="card">
                <div className="header text-right pb-0">
                    <Link to="/app-users/create" className="btn btn-primary btn-sm">Create</Link>
                </div>
                <div className="body table-responsive">
                    <BootstrapTable bootstrap4={true}
                        keyField='_id'
                        loading={loading}
                        data={properties}
                        columns={columns}
                        headerWrapperClasses="thead-light"
                        pagination={paginationFactory({
                            page,
                            sizePerPage,
                            totalSize: total,
                            withFirstAndLast: true,
                            alwaysShowAllBtns: true
                        })}
                        filter={filterFactory()}
                        filterPosition="top"
                        defaultSorted={[{ dataField: 'createdAt', order: 'desc' }]}
                        overlay={overlayFactory()}
                        onTableChange={onTableChange}
                        remote={{
                            filter: true,
                            pagination: true,
                            sort: true,
                            cellEdit: false
                        }}
                    />
                </div>
            </div>
        </div>
    );
}


export default connect(null, {
    listUserAction,
    rejectUserAction,
    approveUserAction,
    deleteUserAction
})(AppUserList)